import React from "react";
import PropTypes from "prop-types";
import { Card, Container } from "react-bootstrap";

/**
 * A layout component with a title, logo, and children content.
 * @param {Object} props - The props for the Layout component.
 * @param {string} props.title - The title of the layout.
 * @param {string} props.logoSrc - The source URL for the logo image.
 * @param {ReactNode} props.children - The content to be rendered inside the layout.
 * @param {string} props.className - Additional CSS class for the layout container.
 */

const LoggedOutLayout = ({ title, logoSrc, children, className, hideLogo, beforeTitle }) => {
  const combinedClassName = `${className ? className + " " : ""}layout-container forgot-password-container login-form`;

  return (
    <Container className={combinedClassName}>
      <Card>
        {!hideLogo && <Card.Img alt="mhc-logo" className="logo" src={logoSrc} />}
        <Card.Body>
          {beforeTitle}
          <h2>{title}</h2>
          {children}
        </Card.Body>
      </Card>
    </Container>
  );
};

LoggedOutLayout.propTypes = {
  title: PropTypes.string,
  logoSrc: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  beforeTitle: PropTypes.node,
};

LoggedOutLayout.defaultProps = {
  title: "Log in",
};

export default LoggedOutLayout;